// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zSnU0 {\n  background-color: transparent;\n}\n\n.DToWs {\n  font-family: var(--font-family-body);\n  font-style: normal;\n  font-weight: normal;\n  font-size: var(--schoolinks-font-size-xs);\n  line-height: 16px;\n  color: var(--color-black);\n  margin: 0 0 var(--spacing-xt-md) 0;\n}\n\n.KYNWv {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  width: 70%;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "zSnU0",
	"label": "DToWs",
	"inputsRow": "KYNWv"
};
export default ___CSS_LOADER_EXPORT___;
